import { AppRouteProps } from "@harea/component";
import React from "react";

const RubriqueListContainer = React.lazy(() => import("./container/RubriqueListContainer"));
const RubriqueFormContainer = React.lazy(() => import("./container/RubriqueFormContainer"));

export const RubriqueRoutes = [
    {
        path: "rubrique",
        element: <RubriqueListContainer />,
        title: "BSMRH.Payroll.Rubrique.Title",
        roles: ["SUPER_ADMIN", "ADMIN", "DIRECTOR_HR"],
    },
    {
        path: "rubrique/create",
        element: <RubriqueFormContainer />,
        title: "BSMRH.Payroll.Rubrique.Form.Title",
        roles: ["SUPER_ADMIN", "ADMIN", "DIRECTOR_HR"],
    },
    {
        path: "rubrique/:id",
        element: <RubriqueFormContainer />,
        title: "BSMRH.Payroll.Rubrique.Form.Title",
        roles: ["SUPER_ADMIN", "ADMIN", "DIRECTOR_HR"],
    },
] as Array<AppRouteProps>;
